import siteCookie from './siteCookie';

const REGISTRATION_COOKIE_NAME = 'registered_from';
const WAMAZING_AFID_COOKIE_NAME = '_wamazing_afid';

export function registrationCompleted() {
  const ck = siteCookie.get(REGISTRATION_COOKIE_NAME);
  return !!ck;
}

// 宿web等から登録完了した場合はfalse
export function registrationCompletedFromSnow() {
  const ck = siteCookie.get(REGISTRATION_COOKIE_NAME);
  if (ck && ck.match(/^\/snow/)) {
    return true;
  }
  return false;
}

export function deleteRegistrationCookie() {
  siteCookie.erase(REGISTRATION_COOKIE_NAME);
}

export function setWamazingAfidToCookie(value) {
  siteCookie.set(WAMAZING_AFID_COOKIE_NAME, value, { expires: 20 * 365 });
}

export function getWamazingAfidFromCookie() {
  return siteCookie.get(WAMAZING_AFID_COOKIE_NAME);
}

// GAイベント送ってURL遷移する && できればturbolinks使う
export function navWithGaEvent(eventName, url) {
  gtag('event', eventName);
  if (typeof Turbolinks === 'object' && Turbolinks && Turbolinks.supported) {
    Turbolinks.visit(url);
  } else {
    location.href = url;
  }
}
